import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestReviewsOnlineLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M11.5598 18.6667H5.33317C3.8665 18.6667 2.6665 19.8667 2.6665 21.3334V29.3334H11.5598V18.6667Z"
          fill="white"
        />
        <path
          d="M17.7735 13.3333H14.2135C12.7469 13.3333 11.5469 14.5333 11.5469 15.9999V29.3333H20.4402V15.9999C20.4402 14.5333 19.2535 13.3333 17.7735 13.3333Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M26.6666 22.6667H20.4399V29.3334H29.3333V25.3334C29.3333 23.8667 28.1333 22.6667 26.6666 22.6667Z"
          fill="white"
        />
        <path
          d="M20.0132 6.46674C20.4266 6.05341 20.5866 5.56007 20.4532 5.13341C20.3199 4.70674 19.9066 4.40008 19.3199 4.30674L18.0399 4.09341C17.9866 4.08007 17.8666 4.00005 17.8399 3.94672L17.1332 2.53339C16.5999 1.45339 15.3866 1.45339 14.8532 2.53339L14.1466 3.94672C14.1199 4.00005 13.9999 4.08007 13.9466 4.09341L12.6666 4.30674C12.0799 4.40008 11.6799 4.70674 11.5332 5.13341C11.3999 5.56007 11.5599 6.05341 11.9732 6.46674L12.9599 7.46674C12.9999 7.50674 13.0532 7.66674 13.0399 7.72008L12.7599 8.94672C12.5466 9.85339 12.8932 10.2667 13.1199 10.44C13.3466 10.6 13.8399 10.8134 14.6532 10.3334L15.8532 9.62673C15.9066 9.58673 16.0799 9.58673 16.1332 9.62673L17.3332 10.3334C17.7066 10.5601 18.0132 10.6267 18.2532 10.6267C18.5332 10.6267 18.7332 10.52 18.8532 10.44C19.0799 10.28 19.4266 9.86672 19.2132 8.94672L18.9332 7.72008C18.9199 7.65341 18.9599 7.50674 19.0132 7.46674L20.0132 6.46674Z"
          fill="white"
        />
      </svg>
      <span>Best Reviews Online</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
